<template>
    <div class="cs-accountList-comment">
      <span v-if="!!data.WorkflowComment">{{ data.WorkflowComment }}</span>
      <span v-if="!!data.AccountPayment1 && !!data.AccountPayment1.Comment">{{ data.AccountPayment1.Comment }}</span>
      <span v-if="!!data.AccountPayment2 &&!!data.AccountPayment2.Comment">{{ data.AccountPayment2.Comment }}</span>
      <span v-if="!!data.AccountPayment3 &&!!data.AccountPayment3.Comment">{{ data.AccountPayment3.Comment }}</span>
      <span v-if="!!data.AccountPayment4 &&!!data.AccountPayment4.Comment">{{ data.AccountPayment4.Comment }}</span>
    </div>
</template>

<style lang="scss" scoped>
.cs-accountList-comment{
  span{
    width: 100%;
    display: block;
  }
}
</style>

<script>

export default {
  props: {
    data: {},
    columnData:{},
    status: {}
  },
  data() {
    return {
    }
  },
  components: {},
  created() {
    
  },
  methods: {
    
  },
  watch: {
    data: function() {
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/accountListCommentCell.vue